import { defineMessages } from 'react-intl';

export default defineMessages({
    manualLossHistoryHeader: {
        id: 'manualLossHistoryTable.The following self-declared losses were only used for an accurate unverified premium.',
        defaultMessage: 'The following self-declared losses were only used for an accurate unverified premium.'
    }
});